import PATHS from '@/router/paths'

const GETTERS = {
  showSearchBar(state, getters, rootState) {
    const { auth: { user } } = rootState
    return !!user
  },
  showLayoutBar(state, getters, rootState, rootGetters) {
    const { tools: { baseReportName } } = rootState

    if (!baseReportName) return false

    const currentReportItems = rootGetters['tools/currentReportItems']
    const isReportRoute = rootGetters['tools/isReportRoute']
    const haveData = currentReportItems || false

    return isReportRoute && !!haveData
  },
  showLegendBar(state, getters, rootState, rootGetters) {
    const { tools: { baseReportName } } = rootState

    if (!baseReportName) return false

    const currentReportItems = rootGetters['tools/currentReportItems']
    const isLegendRoute = ['discrepancy', 'pacing'].includes(baseReportName)

    return isLegendRoute && !!currentReportItems
  },
  showExportBar(state, getters, rootState, rootGetters) {
    const { tools: { baseReportName } } = rootState

    if (!baseReportName) return false

    const isInternalRoute = rootGetters['tools/isInternalRoute']
    const currentReportItems = rootGetters['tools/currentReportItems']
    const isReportRoute = rootGetters['tools/isReportRoute']

    const isExportRoute = isReportRoute || isInternalRoute
    const haveData = currentReportItems || false

    return isExportRoute && !!haveData
  },
  showFilterBar(state, getters, rootState, rootGetters) {
    const { tools: { baseReportName } } = rootState
    const currentReportItems = rootGetters['tools/currentReportItems']
    const isReportRoute = rootGetters['tools/isReportRoute']

    const excludedRoutes = [PATHS.INTERNAL.TIME_SHEET]
    const isFilterRoute = isReportRoute && excludedRoutes.indexOf(baseReportName) === -1
    const haveData = currentReportItems || false

    return isFilterRoute && !!haveData
  },
  showDataFreshness(state, getters) {
    return getters.showSearchBar
  },

  backgroundColor(state, getters, rootState, rootGetters) {
    const inDarkMode = rootGetters['auth/inDarkMode']
    return inDarkMode ? 'black' : 'icewhite'
  },
  clearColor(state, getters, rootState, rootGetters) {
    const inDarkMode = rootGetters['auth/inDarkMode']
    return inDarkMode ? 'vuetifyblack' : 'white'
  },
  iceColor(state, getters, rootState, rootGetters) {
    const inDarkMode = rootGetters['auth/inDarkMode']
    return inDarkMode ? 'vuetifyblackhighlight' : 'icewhite'
  },
  midColor(state, getters, rootState, rootGetters) {
    const inDarkMode = rootGetters['auth/inDarkMode']
    return inDarkMode ? 'vuetifygray' : 'darkblue'
  },
  textColor(state, getters, rootState, rootGetters) {
    const inDarkMode = rootGetters['auth/inDarkMode']
    return inDarkMode ? 'midgray' : 'coolgray'
  },
  titleColor(state, getters, rootState, rootGetters) {
    const inDarkMode = rootGetters['auth/inDarkMode']
    return inDarkMode ? 'coolgray' : 'blueblack'
  },
}

export default GETTERS
